import { ReceptionDTO } from "./reception";

export class DashboardKpiDTO {
    totalRevenue: number = 0;
    totalProfit: number = 0;
    totalCost: number = 0;
    totalArrears: number = 0;
    arrearsCount: number = 0;
    tripPending: number = 0;
}

export class DashboardDataDTO {
    kpi: DashboardKpiDTO = new DashboardKpiDTO();
    exchangeInboundList: ReceptionDTO[] = [];
    tripInboundList: ReceptionDTO[] = [];
    arrearsList: ReceptionDTO[] = [];
}